import VSlider from './VSlider'

export { VSlider }
export default VSlider



// WEBPACK FOOTER //
// ../../../src/components/VSlider/index.ts